import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { Button, Input,Form ,FormItem,Dialog } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.config.productionTip = false
Vue.use(Button).use(Input).use(Form).use(FormItem).use(Dialog)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
